var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdviserMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7885 25.4144C8.41194 26.1265 3 28.4695 3 31.25C3 34.5956 10.835 37.3077 20.5 37.3077C30.165 37.3077 38 34.5956 38 31.25C38 28.4695 32.5881 26.1265 25.2115 25.4144",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 2.98077C14.8461 2.98077 10.4038 7.42308 10.4038 13.0769C10.4038 17.3846 12.6923 21.0192 15.25 24.6539L20.5 32.3269L25.75 24.6539C28.3077 21.0192 30.5961 17.3846 30.5961 13.0769C30.5961 7.42308 26.1538 2.98077 20.5 2.98077Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 17.1153C22.7303 17.1153 24.5383 15.3073 24.5383 13.0769C24.5383 10.8465 22.7303 9.03842 20.4999 9.03842C18.2695 9.03842 16.4614 10.8465 16.4614 13.0769C16.4614 15.3073 18.2695 17.1153 20.4999 17.1153Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviserMap);
export default __webpack_public_path__ + "static/media/AdviserMap.6fc8ef2a88cf6580f5b434b6c9b0d80d.svg";
export { ForwardRef as ReactComponent };